/* =============================================================
   RONCASA — DISTRICT / TOWN PAGE HUB
   Shared behavior for all district-town-*.liquid sections.
   Loaded once by district-town-ticker.liquid (defer).
   Reads area config from #dth-area-data (JSON script tag written by
   district-town-map.liquid, populated from page metafields) — no
   hardcoded per-area values here, unlike the mockup this was ported from.
   ============================================================= */
(function () {
  'use strict';

  // ── Ticker pause on hover ──
  document.querySelectorAll('.dth-ticker-row').forEach(function (row) {
    var track = row.querySelector('.dth-t-track');
    if (!track) return;
    row.addEventListener('mouseenter', function () { track.style.animationPlayState = 'paused'; });
    row.addEventListener('mouseleave', function () { track.style.animationPlayState = 'running'; });
  });

  // ── Section nav scrollspy ──
  // NOTE: the active link is centered by scrolling `.dth-sect-nav`'s own
  // scrollLeft directly (NOT Element.scrollIntoView). scrollIntoView's
  // "nearest" edge calc is unreliable against a `position: sticky` ancestor
  // (this nav is sticky) — it was dragging the whole page's vertical scroll
  // backward every time a new section crossed the observer threshold,
  // pinning the page mid-scroll. Confirmed via bisect: neutralizing only
  // the scrollIntoView call (leaving the rest of this IIFE running)
  // eliminated the bounce entirely. See district-11 scroll-bounce fix, 2026-09-16.
  var sectLinks = document.querySelectorAll('.dth-sect-nav a[href^="#"]');
  var sectEls = Array.prototype.map.call(sectLinks, function (a) {
    return document.getElementById(a.getAttribute('href').slice(1));
  }).filter(Boolean);
  if (sectEls.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var id = e.target.id;
          sectLinks.forEach(function (a) {
            var isMatch = a.getAttribute('href') === '#' + id;
            a.classList.toggle('on', isMatch);
            if (isMatch) {
              var navEl = a.closest('.dth-sect-nav');
              if (navEl) {
                var linkRect = a.getBoundingClientRect();
                var navRect = navEl.getBoundingClientRect();
                var delta = (linkRect.left + linkRect.right) / 2 - (navRect.left + navRect.right) / 2;
                if (Math.abs(delta) > 1) navEl.scrollBy({ left: delta, behavior: 'smooth' });
              }
            }
          });
        }
      });
    }, { rootMargin: '-160px 0px -55% 0px', threshold: 0 });
    sectEls.forEach(function (el) { obs.observe(el); });
  }

  // ── Generic tab buttons (visual toggle only — pipeline "By project/By bedroom" etc.) ──
  document.querySelectorAll('.dth-tab-btns').forEach(function (group) {
    group.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        group.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
      });
    });
  });

  // ── PSF / Nearby tab switch inside the map panel ──
  document.querySelectorAll('.dth-dp-tab-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.dth-tab-btns');
      group.querySelectorAll('.dth-dp-tab-btn').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
      var target = btn.dataset.tab;
      var scope = btn.closest('.dth-dist-panel') || document;
      scope.querySelectorAll('.dth-dp-tabbed').forEach(function (panel) {
        panel.classList.toggle('on', panel.dataset.tabPanel === target);
      });
      if (target === 'nearby' && window.dthMap) {
        setTimeout(function () { window.dthMap.invalidateSize(); }, 30);
      }
    });
  });

  // ── Interactive map — Leaflet + clustering + live roncasa-location-api pull ──
  // One map per page (unlike the mockup, which ran two side-by-side for preview).
  var mapEl = document.getElementById('dth-leaflet-map');
  var areaDataEl = document.getElementById('dth-area-data');
  if (!mapEl || !areaDataEl || typeof L === 'undefined') return;

  var AREA; // {center, zoom, minZoom, maxZoom, bounds, cats, pins}
  try { AREA = JSON.parse(areaDataEl.textContent); } catch (e) { console.warn('[roncasa] dth-area-data JSON parse failed', e); return; }

  // Always pull transaction pins alongside the metafield-configured amenity categories —
  // hdb for Town pages, resale for District pages — without needing every existing page's
  // map_config metafield updated. Dynamically add the matching filter chip if map.liquid's
  // cats_source loop didn't already render one for it.
  AREA.cats = AREA.cats || [];
  var extraCat = (areaDataEl.dataset.isTown === 'true') ? 'hdb' : 'resale';
  if (AREA.cats.indexOf(extraCat) === -1) AREA.cats.push(extraCat);
  var filtersEl = document.querySelector('.dth-map-filters');
  if (filtersEl && !filtersEl.querySelector('[data-cat="' + extraCat + '"]')) {
    var extraChip = document.createElement('button');
    extraChip.className = 'dth-map-chip on';
    extraChip.dataset.cat = extraCat;
    extraChip.textContent = extraCat === 'hdb' ? 'HDB Blocks' : 'Resale';
    filtersEl.appendChild(extraChip);
  }

  // Town pages only: carparks baked into page metafield dth.map_carparks (build_town_carparks.py).
  // Not an API category (Parking Kaki's full feed is ~6.5 MB), so they merge into every
  // renderPins() call below instead of going through fetchLivePins(). Chip starts off — ~100+
  // pins would crowd the amenity view by default.
  var CARPARKS = [];
  var cpEl = document.getElementById('dth-carpark-data');
  if (cpEl) { try { CARPARKS = JSON.parse(cpEl.textContent) || []; } catch (e) { CARPARKS = []; } }
  if (CARPARKS.length && filtersEl && !filtersEl.querySelector('[data-cat="carpark"]')) {
    var cpChip = document.createElement('button');
    cpChip.className = 'dth-map-chip';
    cpChip.dataset.cat = 'carpark';
    cpChip.textContent = 'Carparks';
    filtersEl.appendChild(cpChip);
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  var BUSY_LABEL = { quiet: 'Easy to find a lot', moderate: 'Gets fairly full' };
  function carparkPopup(c) {
    var meta = [c.kind === 'HDB' ? 'HDB car park' : c.kind + ' car park'];
    if (c.type) meta[0] += ', ' + c.type.replace(/ car park$/, '');
    if (c.lots) meta.push(c.lots + ' lots'); else if (c.lots_est) meta.push('about ' + c.lots_est + ' lots');
    if (c.night) meta.push('night parking');
    var h = '<b>' + esc(c.name) + '</b><br>' + esc(meta.join(' · '));
    h += '<br>' + (c.rate ? esc(c.rate) : 'Rates not available');
    if (c.ev) h += '<br>EV charging: ' + c.ev + ' point' + (c.ev > 1 ? 's' : '');
    if (c.busy) {
      [['wk_eve', 'Weeknights 6-11pm'], ['wk_day', 'Weekdays 8am-6pm'], ['we_day', 'Weekends 10am-6pm']].forEach(function (w) {
        if (c.busy[w[0]]) h += '<br>' + w[1] + ': ' + (BUSY_LABEL[c.busy[w[0]]] || 'Often full');
      });
    }
    return h;
  }
  var CARPARK_PINS = CARPARKS.map(function (c) {
    return { name: c.name, cat: 'carpark', lat: c.lat, lng: c.lng, popup: carparkPopup(c) };
  });

  var CAT_TO_API_TYPE = { transport: 'mrt', mall: 'mall', park: 'park', food: 'food', school: 'school', resale: 'resale', hdb: 'hdb' };
  var LOCATION_API_BASE = 'https://api.roncasa.co/nearby';

  var ICON_SVG = {
    transport: '<svg viewBox="0 0 16 16"><rect x="3" y="2" width="10" height="9" rx="2"/><line x1="3" y1="7" x2="13" y2="7"/><circle cx="6" cy="13" r="1"/><circle cx="10" cy="13" r="1"/></svg>',
    mall:      '<svg viewBox="0 0 16 16"><path d="M4 5 L5 2 H11 L12 5"/><rect x="3" y="5" width="10" height="9" rx="1"/></svg>',
    park:      '<svg viewBox="0 0 16 16"><circle cx="8" cy="6" r="4"/><line x1="8" y1="10" x2="8" y2="14"/></svg>',
    food:      '<svg viewBox="0 0 16 16"><line x1="4" y1="2" x2="4" y2="7"/><line x1="6" y1="2" x2="6" y2="7"/><line x1="8" y1="2" x2="8" y2="7"/><line x1="6" y1="7" x2="6" y2="14"/><path d="M12 2 C10 2 10 6 12 6 L12 14"/></svg>',
    school:    '<svg viewBox="0 0 16 16"><polygon points="8,3 14,6 8,9 2,6"/><line x1="8" y1="9" x2="8" y2="13"/><line x1="4" y1="7" x2="4" y2="10"/></svg>',
    resale:    '<svg viewBox="0 0 16 16"><rect x="3" y="2" width="10" height="12" rx="1"/><line x1="6" y1="5" x2="6" y2="5.5"/><line x1="10" y1="5" x2="10" y2="5.5"/><line x1="6" y1="8" x2="6" y2="8.5"/><line x1="10" y1="8" x2="10" y2="8.5"/><line x1="6" y1="11" x2="6" y2="11.5"/><line x1="10" y1="11" x2="10" y2="11.5"/></svg>',
    hdb:       '<svg viewBox="0 0 16 16"><rect x="2" y="3" width="12" height="10" rx="1"/><line x1="2" y1="7" x2="14" y2="7"/><line x1="6" y1="3" x2="6" y2="13"/><line x1="10" y1="3" x2="10" y2="13"/></svg>',
    carpark:   '<svg viewBox="0 0 16 16"><rect x="2" y="2" width="12" height="12" rx="2"/><path d="M6.5 12V4.5H9a2 2 0 0 1 0 4H6.5"/></svg>'
  };
  var CAT_LABEL = { transport: 'T', mall: 'M', park: 'P', food: 'F', school: 'S', resale: 'R', hdb: 'H', carpark: 'C' };

  function normalizePOI(apiType, rec) {
    if (apiType === 'mrt') return { name: rec.station + (rec.exit ? ' · ' + rec.exit : ''), lat: rec.lat, lng: rec.lng };
    if (apiType === 'mall') return { name: rec.nm || rec.name, lat: rec.lat, lng: rec.lng };
    if (apiType === 'resale' || apiType === 'hdb') {
      return { name: rec.name, lat: rec.lat, lng: rec.lng, psf: rec.psf, lastTxn: rec.last_txn_month };
    }
    return { name: rec.name, lat: rec.lat, lng: rec.lng }; // food, school, park share `name`
  }

  // Live pull from roncasa-location-api, scoped to this area's center + max 2km radius per
  // category. Falls back to AREA.pins (metafield-supplied illustrative/seed data) on any
  // failure (offline, CORS, endpoint down) — the page must never break if the API is down.
  function fetchLivePins() {
    var cats = AREA.cats || [];
    var promises = cats.map(function (cat) {
      var apiType = CAT_TO_API_TYPE[cat];
      var url = LOCATION_API_BASE + '?lat=' + AREA.center[0] + '&lng=' + AREA.center[1] + '&type=' + apiType + '&radius=2000&limit=30';
      return fetch(url).then(function (res) {
        if (!res.ok) throw new Error(apiType + ' returned ' + res.status);
        return res.json();
      }).then(function (body) {
        return (body.results || []).map(function (rec) {
          var n = normalizePOI(apiType, rec);
          if (n.lat == null || n.lng == null || !n.name) return null;
          var pin = { name: n.name, cat: cat, lat: n.lat, lng: n.lng };
          if (n.psf != null) { pin.psf = n.psf; pin.lastTxn = n.lastTxn; }
          return pin;
        }).filter(Boolean);
      });
    });
    return Promise.all(promises).then(function (arrays) { return arrays.reduce(function (a, b) { return a.concat(b); }, []); });
  }

  // Pad the area's bounds by ~25% before locking pan to them (3 Aug 2026,
  // Ronnie feedback) — the raw metafield box felt too tight/aggressive when
  // panning near its edge. Still locked to roughly the district/town (he
  // explicitly wants that kept, unlike the Schools page which drops the
  // lock entirely), just with breathing room instead of a hard wall, and a
  // softer viscosity so hitting the edge doesn't feel like a shove back.
  var rawBounds = AREA.bounds;
  var latPad = (rawBounds[1][0] - rawBounds[0][0]) * 0.25;
  var lngPad = (rawBounds[1][1] - rawBounds[0][1]) * 0.25;
  var paddedBounds = [
    [rawBounds[0][0] - latPad, rawBounds[0][1] - lngPad],
    [rawBounds[1][0] + latPad, rawBounds[1][1] + lngPad]
  ];

  var map = L.map(mapEl, {
    center: AREA.center, zoom: AREA.zoom, minZoom: AREA.minZoom, maxZoom: AREA.maxZoom,
    maxBounds: paddedBounds, maxBoundsViscosity: 0.6, scrollWheelZoom: false
  });
  window.dthMap = map;

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; OpenStreetMap', maxZoom: 19
  }).addTo(map);

  // Ctrl/Cmd + scroll to zoom — plain scroll keeps scrolling the page.
  var mapContainerEl = map.getContainer();
  var zoomHintEl = document.createElement('div');
  zoomHintEl.className = 'dth-map-zoom-hint';
  zoomHintEl.textContent = 'Ctrl + scroll to zoom';
  mapContainerEl.appendChild(zoomHintEl);
  mapContainerEl.addEventListener('wheel', function (e) {
    if (e.ctrlKey || e.metaKey) {
      e.preventDefault();
      if (e.deltaY < 0) map.zoomIn(); else map.zoomOut();
      zoomHintEl.style.opacity = '0';
    }
  }, { passive: false });
  mapContainerEl.addEventListener('mouseleave', function () { zoomHintEl.style.opacity = ''; });

  var layersByCat = {};
  var markerRefs = [];
  var listEl = document.getElementById('dth-nearby-list');

  function renderNearbyList() {
    if (!listEl) return;
    var b = map.getBounds();
    var visible = markerRefs.filter(function (m) { return b.contains([m.lat, m.lng]); });
    listEl.innerHTML = '';
    if (!visible.length) { listEl.innerHTML = '<div class="dth-nearby-empty">Nothing in view — pan or zoom out a little.</div>'; return; }
    visible.forEach(function (m) {
      var row = document.createElement('button');
      row.className = 'dth-nearby-row';
      row.innerHTML = '<span class="dth-nr-badge">' + (ICON_SVG[m.cat] || CAT_LABEL[m.cat]) + '</span><span class="dth-nb-name">' + m.name + '</span><span class="dth-nb-cat">' + m.cat + '</span>';
      row.addEventListener('click', function () { map.flyTo([m.lat, m.lng], AREA.maxZoom - 1); m.marker.openPopup(); });
      listEl.appendChild(row);
    });
  }

  // Ink-only cluster "balloon" — count shown, no color-coded severity tiers (design system
  // bans semantic colors in chrome). Splits automatically as you zoom in.
  function clusterIconFn(cluster) {
    var n = cluster.getChildCount();
    var tier = n < 10 ? 'sm' : n < 30 ? 'md' : 'lg';
    return L.divIcon({ html: '<div class="dth-cluster ' + tier + '">' + n + '</div>', className: '', iconSize: null });
  }

  function renderPins(pins) {
    Object.keys(layersByCat).forEach(function (k) { map.removeLayer(layersByCat[k]); delete layersByCat[k]; });
    markerRefs.length = 0;
    pins.forEach(function (p) {
      var icon = L.divIcon({ className: '', html: '<div class="dth-pin">' + (ICON_SVG[p.cat] || '') + '</div>', iconSize: [24, 24], iconAnchor: [12, 12] });
      var popupHtml = p.popup ? p.popup : p.psf != null
        ?'<b>' + p.name + '</b><br>$' + p.psf.toLocaleString() + ' psf' + (p.lastTxn ? ' · last txn ' + p.lastTxn.slice(0, 7) : '')
        : '<b>' + p.name + '</b><br>' + p.cat;
      var marker = L.marker([p.lat, p.lng], { icon: icon }).bindPopup(popupHtml);
      if (!layersByCat[p.cat]) {
        layersByCat[p.cat] = (typeof L.markerClusterGroup === 'function')
          ? L.markerClusterGroup({ iconCreateFunction: clusterIconFn, showCoverageOnHover: false, spiderfyOnMaxZoom: true, maxClusterRadius: 50 })
          : L.layerGroup();
      }
      marker.addTo(layersByCat[p.cat]);
      markerRefs.push(Object.assign({ marker: marker }, p));
    });
    // Respect chip state (a re-render after the live pull must not re-show a layer the user
    // switched off, nor show the carpark layer that starts off).
    Object.keys(layersByCat).forEach(function (k) {
      var chip = document.querySelector('.dth-map-chip[data-cat="' + k + '"]');
      if (!chip || chip.classList.contains('on')) layersByCat[k].addTo(map);
    });
    renderNearbyList();
  }

  map.on('moveend zoomend', renderNearbyList);

  renderPins((AREA.pins || []).concat(CARPARK_PINS)); // seed pins from metafield, shown immediately
  fetchLivePins().then(function (livePins) {
    if (livePins.length) renderPins(livePins.concat(CARPARK_PINS));
  }).catch(function (err) {
    console.warn('[roncasa] live location-api unreachable (' + err.message + ') — keeping seed pins.');
  });

  document.querySelectorAll('.dth-map-chip').forEach(function (chip) {
    chip.addEventListener('click', function () {
      var cat = chip.dataset.cat;
      var isOn = chip.classList.toggle('on');
      var lg = layersByCat[cat];
      if (!lg) return;
      if (isOn) map.addLayer(lg); else map.removeLayer(lg);
      renderNearbyList();
    });
  });
})();
